module.exports = __webpack_public_path__ + "img/jinggao.ec4ac72e.svg";